export default "__VITE_ASSET__CiAtrJVz__"